import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import Products from './pages/productspage';
import Checkout from './pages/Checkout';
import HowToOrder from './pages/HowToOrder';
import PortfolioPage from './pages/PortfolioPage';
import QuotesPage from './pages/QuotesPage'; 

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Header />
      <main style={{ minHeight: '80vh' }}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/portfolio" element={<PortfolioPage />} />
          <Route path="/howtoorder" element={<HowToOrder />} />
          <Route path="/quotes" element={<QuotesPage />} />
          <Route path="/products" element={<Products />} />
        </Routes>
      </main>
      <Footer />
    </Router>
  );
}

export default App;
